import * as React from "react";
import { SpaceBetween, Popover, Link } from "@amzn/awsui-components-react";
import { ContentEvaluationModel } from "../../model/content-evaluation-model";

export const EvaluationFinding: React.FC<ContentEvaluationModel.EvaluationFindingProps> = ({ finding, index }) => {
    return (
        <div style={{
            marginBottom: "20px",
            padding: "16px",
            backgroundColor: "#fefefe",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            borderLeft: "4px solid #d97706"
        }}>
            <SpaceBetween size="s">
                <div>
                    <h4 style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        margin: "0 0 8px 0"
                    }}>
                        🔍 Finding #{index + 1}: {finding.flaggedRule}
                    </h4>
                </div>

                <div style={{
                    backgroundColor: "#fef2f2",
                    padding: "12px",
                    borderRadius: "6px",
                    border: "1px solid #fecaca"
                }}>
                    <p style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#475569",
                        margin: "0 0 4px 0",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px"
                    }}>
                        Flagged Content:
                        <Popover
                            dismissAriaLabel="Close"
                            size="small"
                            triggerType="text"
                            content="This shows the specific text from your content that doesn't follow the guidelines or rules."
                        >
                            <Link variant="info">Info</Link>
                        </Popover>
                    </p>
                    <p style={{
                        fontSize: "14px",
                        fontStyle: "italic",
                        margin: "0",
                        wordBreak: "break-word"
                    }}>
                        "{finding.flaggedPassage}"
                    </p>
                </div>

                <div style={{
                    backgroundColor: "#f8fafc",
                    padding: "12px",
                    borderRadius: "6px",
                    border: "1px solid #e2e8f0"
                }}>
                    <p style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#475569",
                        margin: "0 0 4px 0",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px"
                    }}>
                        Explanation:
                        <Popover
                            dismissAriaLabel="Close"
                            size="small"
                            triggerType="text"
                            content="This explains why the flagged text is problematic and what rule or guideline it breaks."
                        >
                            <Link variant="info">Info</Link>
                        </Popover>
                    </p>
                    <p style={{
                        fontSize: "14px",
                        color: "#64748b",
                        margin: "0",
                        lineHeight: "1.5"
                    }}>
                        {finding.description}
                    </p>
                </div>

                {finding.suggestedPassages && (
                    <div style={{
                        backgroundColor: "#f0fdf4",
                        padding: "12px",
                        borderRadius: "6px",
                        border: "1px solid #86efac"
                    }}>
                        <p style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#166534",
                            margin: "0 0 4px 0",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                        }}>
                            Revised Examples:
                            <Popover
                                dismissAriaLabel="Close"
                                size="small"
                                triggerType="text"
                                content="These are suggested ways to rewrite the flagged text so it follows the guidelines. You can use these as examples to fix similar issues."
                            >
                                <Link variant="info">Info</Link>
                            </Popover>
                        </p>
                        <div style={{
                            fontSize: "14px",
                            color: "#15803d",
                            fontStyle: "italic",
                            margin: "0",
                            wordBreak: "break-word"
                        }}>
                            {Array.isArray(finding.suggestedPassages)
                                ? finding.suggestedPassages.map((passage: string, passageIndex: number) => (
                                    <p key={passageIndex} style={{ margin: "4px 0" }}>
                                        • "{passage}"
                                    </p>
                                ))
                                : <p style={{ margin: "0" }}>• "{finding.suggestedPassages}"</p>
                            }
                        </div>
                    </div>
                )}
            </SpaceBetween>
        </div>
    );
};
